'use client';
import Checkbox from "./Checkbox.js";
export default Checkbox;